import { withConfig } from "@/utils/withConfig";
import { DonationSummaryWithStore } from "./DonationSummaryWithStore";
import type { DonationSummaryWithStoreProps } from "./DonationSummaryProps";

export * from "./DonationSummary";
export * from "./DonationSummaryProps";
export * from "./DonationSummaryWithStore";

export const DonationSummaryWithConfig =
  withConfig<DonationSummaryWithStoreProps>(
    DonationSummaryWithStore,
    "donation_summary",
  );
